export default __webpack_public_path__ + "f1a1d239a86cfd32d86acb41a210fbf0.svg";